
import { Types } from "./actionTypes";
import { MONITOR_PARAMETER, RESP_OBJ, PLETH_OBJ } from '../../common/constant/common-constants'; // adjust path


const Ecg_keys = [
    MONITOR_PARAMETER.HR.toString(),
    MONITOR_PARAMETER.RR.toString()
];

const Spo2_keys = [
    MONITOR_PARAMETER.SPO2.toString(),
    MONITOR_PARAMETER.SPO2_PERFUSION_INDEX.toString(),
    MONITOR_PARAMETER.SPO2_PULSE_RATE.toString()
];

const NIBP_keys = [
    MONITOR_PARAMETER.NIBP_SYSTOLIC.toString(),
    MONITOR_PARAMETER.NIBP_DIASTOLIC.toString(),
    MONITOR_PARAMETER.NIBP_MEAN.toString(),
    MONITOR_PARAMETER.NIBP_PULSE_RATE.toString()
];

const Temp_keys = [
    MONITOR_PARAMETER.TEMPERATURE_1.toString(),
    MONITOR_PARAMETER.TEMPERATURE_2.toString(),
    MONITOR_PARAMETER.TEMPERATURE_DIFF.toString()
];

const Resp_graph_keys = [RESP_OBJ.id.toString()];
const Spo2_graph_keys = [PLETH_OBJ.id.toString()];

export const bedDetailAction = (task) => {

    return {
        type: Types.BED_DETAILS,
        payload: task
    }
}

export const bedIdAction = (task) => {

    return {
        type: Types.BED_ID_ARRAY,
        payload: task
    }
}

export const hospitalDataAction = (task) => {

    return {
        type: Types.HOSPITAL_DATA,
        payload: task
    }
}


export const sidebarActiveIconAction = (task) => {
    return {
        type: Types.SIDEBAR_ACTIVE_ICON,
        payload: task,
    }
}

export const activeDeviceAction = (task) => {
    return {
        type: Types.ACTIVE_DEVICE,
        payload: task,
    }
}

export const userViewAction = (task) => {
    return {
        type: Types.USER_VIEW,
        payload: task,
    }
}

export const wardDetailsAction = (task) => {

    return {
        type: Types.WARD_DATA,
        payload: task
    }
}

export const patientDataAction = (task) => {

    return {
        type: Types.PATIENT_DATA,
        payload: task
    }
}
export const patienDischargeAction = (task) => {
    return {
        type: Types.PATIENT_DISCHARGE,
        payload: task
    }
}


// Action for putting DB data(vitals) in reducer during sign-out/refresh

export const deviceVitalDataAction_DB_NIBP = (task) => {
    if (task?.monitorParameter?.nibp) {

        let nibpTask = {
            bedId: task.bedId,
            deviceId: task.monitorParameter.noccarcPatientMonitorId,
            deviceType: "NOCCARC_PM_NX5",
            monitorParameter: task.monitorParameter.nibp

        }
        return {
            type: Types.DEVICE_VITAL_DATA_NIBP,
            payload: nibpTask
        }




    }

}
export const deviceVitalDataAction_DB_TEMP = (task) => {

    if (task?.monitorParameter?.temp) {

        let tempTask = {
            bedId: task.bedId,
            deviceId: task.monitorParameter.noccarcPatientMonitorId,
            deviceType: "NOCCARC_PM_NX5",
            monitorParameter: task.monitorParameter.temp

        }

        return {
            type: Types.DEVICE_VITAL_DATA_TEMP,
            payload: tempTask
        }

    }

}
export const deviceVitalDataAction_DB_SPO2 = (task) => {

    if (task?.monitorParameter?.spo2) {

        let spo2Task = {
            bedId: task.bedId,
            deviceId: task.monitorParameter.noccarcPatientMonitorId,
            deviceType: "NOCCARC_PM_NX5",
            monitorParameter: task.monitorParameter.spo2



        }

        return {
            type: Types.DEVICE_VITAL_DATA_SPO2,
            payload: spo2Task
        }


    }
}
export const deviceVitalDataAction_DB_ECG = (task) => {

    if (task?.monitorParameter?.ecg) {

        let ecgTask = {
            bedId: task.bedId,
            deviceId: task.monitorParameter.noccarcPatientMonitorId,
            deviceType: "NOCCARC_PM_NX5",
            monitorParameter: task.monitorParameter.ecg

        }

        return {
            type: Types.DEVICE_VITAL_DATA_ECG,
            payload: ecgTask
        }



    }
}


// Action for putting data(vitals) from socket(live) in reducer
export const deviceVitalDataAction = (task) => {
    // console.log("Action of Monitor_params------------------>" ,task);

    const packet_Keys = task.monitorParameter
    // console.log(packet_Keys)
    const is_ECG_parmas = Ecg_keys.every(key => key in packet_Keys);
    const is_NIBP_params = NIBP_keys.every(key => key in packet_Keys);
    const is_Temp_parmas = Temp_keys.every(key => key in packet_Keys);
    const is_Spo2_params = Spo2_keys.every(key => key in packet_Keys);

    // console.log(is_ECG_parmas)
    // console.log(is_Spo2_params)




    if (is_ECG_parmas) {
        return {
            type: Types.DEVICE_VITAL_DATA_ECG,
            payload: task
        }

    }
    else if (is_NIBP_params) {
        return {
            type: Types.DEVICE_VITAL_DATA_NIBP,
            payload: task
        }

    }
    else if (is_Temp_parmas) {
        return {
            type: Types.DEVICE_VITAL_DATA_TEMP,
            payload: task
        }

    }
    else if (is_Spo2_params) {
        return {
            type: Types.DEVICE_VITAL_DATA_SPO2,
            payload: task
        }

    }


}

export const monitorHeartbeatAction = (task) => {
    return {
        type: Types.MONITOR_HEARTBEAT_DATA,
        payload: task
    }
}


export const deviceEcgWaveformDataAction = (task) => {
    // console.log("task::::::::::::::", task)
    return {
        type: Types.DEVICE_ECG_WAVEFORM_DATA,
        payload: task
    }
}

export const deviceHrWaveformDataAction = (task) => {
    // console.log("deviceHrWaveformDataAction------------------>", task);
    const packet_Keys = task.secondaryWaveforms

    const is_Resp_parmas = Resp_graph_keys.every(key => key in packet_Keys);
    const is_Pleth_params = Spo2_graph_keys.every(key => key in packet_Keys);

    if (is_Resp_parmas) {
        return {
            type: Types.DEVICE_RESP_WAVEFORM_DATA,
            payload: task
        }

    }
    else if (is_Pleth_params) {
        return {
            type: Types.DEVICE_PLETH_WAVEFORM_DATA,
            payload: task
        }

    }


}

export const alarmDataAction = (task) => {

    // console.log("PM_noccarc_Alarms------------------------------>", task)
    return {
        type: Types.NOCCARC_PM_ALARM_DATA,
        payload: task
    }
}

export const ventilatorAlarmDataAction = (task) => {
    return {
        type: Types.VENTILATOR_ALARM_DATA,
        payload: task
    }
}

export const ventilatorAdditionalFeaturesDataAction = (task) => {
    return {
        type: Types.VENTILATOR_ADDITIONAL_FEATURES_DATA,
        payload: task
    }
}

export const ventilatorModuleConnectionStatusAction = (task) => {
    return {
        type: Types.VENTILATOR_MODULE_CONNECTION_STATUS_DATA,
        payload: task
    }
}

export const ventilatorHeartbeatAction = (task) => {
    return {
        type: Types.VENTILATOR_HEARTBEAT_DATA,
        payload: task
    }
}

export const notificationDataAction = (task) => {

    return {
        type: Types.NOTIFICATION_DATA,
        payload: task
    }
}

export const viewTypeAction = (task) => {

    return {
        type: Types.CONFIG_VIEW_TYPE,
        payload: task
    }
}

export const filterAction = (task) => {

    return {
        type: Types.CONFIG_FILTER_TYPE,
        payload: task
    }
}

export const modalAction = (task) => {

    return {
        type: Types.CONFIG_MODAL,
        payload: task
    }
}

export const favoriteBedAction = (task) => {

    return {
        type: Types.FAVORITE_BED_ID_ARRAY,
        payload: task
    }
}

export const bedDetailConfigAction = (task) => {

    return {
        type: Types.CONFIG_BED_DETAILS,
        payload: task
    }
}

export const addColumnBedListAction = (task) => {

    return {
        type: Types.CONFIG_ADD_COLUMN,
        payload: task
    }
}

export const removeColumnBedListAction = (task) => {

    return {
        type: Types.CONFIG_REMOVE_COLUMN,
        payload: task
    }
}

export const clearAlarms = () => {

    return {
        type: Types.CLEAR_ALARM,
        payload: null
    }
}

export const clearBedAlarm = (task) => {
    return {
        type: Types.CLEAR_BED_ALARM,
        payload: task,
    }
}

export const clearStore = () => {

    return {
        type: Types.CLEAR_STORE,
        payload: null
    }
}

export const selectedBedAction = (task) => {
    return {
        type: Types.SELECTED_BED,
        payload: task
    }
}

export const selectedWardAction = (task) => {
    return {
        type: Types.SELECTED_WARD,
        payload: task
    }
}

export const ventilatorVitalDataAction = (task) => {
    return {
        type: Types.VENTILATOR_VITAL_DATA,
        payload: task,
    }
}

export const ventilatorStandbyDataAction = (task) => {
    return {
        type: Types.VENTILATOR_STANDBY_DATA,
        payload: task,
    }
}

export const ventilatorPatientModeAlarmProfileDataAction = (task) => {
    return {
        type: Types.VENTILATOR_PATIENT_MODE_ALARM_PROFILE_DATA,
        payload: task,
    }
}

export const ventilatorWaveformDataAction = (task) => {
    return {
        type: Types.VENTILATOR_WAVEFORM_DATA,
        payload: task,
    }
}


export const ventilatorPatientHistoryTimeData = (task) => {

    return {
        type: Types.VENTILATOR_PATIENT_HISTORY_TIME_DATA,
        payload: task,
    }
}


export const ventilatorPatientHistoryGraphApiData = (task) => {
    return {
        type: Types.VENTILATOR_PATIENT_HISTORY_GRAPH_API_DATA,
        payload: task,
    }
}

export const ventilatorPatientHistoryCursorData = (task) => {
    return {
        type: Types.VENTILATOR_PATIENT_HISTORY_CURSOR_DATA,
        payload: task,
    }
}

export const ventilatorPatientHistoryCurrentCursorTime = (task) => {
    return {
        type: Types.VENTILATOR_PATIENT_HISTORY_CURRENT_CURSOR_TIME,
        payload: task,
    }
}

export const ventilatorPatientHistoryPatientModeAPData = (task) => {
    return {
        type: Types.VENTILATOR_PATIENT_HISTORY_PATIENT_MODE_AP_DATA,
        payload: task,
    }
}

export const ventilatorPatientHistoryEventHistoryData = (task) => {
    return {
        type: Types.VENTILATOR_PATIENT_HISTORY_EVENT_HISTORY_DATA,
        payload: task,
    }
}

export const ventilatorPatientHistoryLiveAlarmHistoryData = (task) => {
    return {
        type: Types.VENTILATOR_PATIENT_HISTORY_LIVE_ALARM_HISTORY_DATA,
        payload: task,
    }
}

export const ventilatorPatientHistoryAdditionalFeaturesData = (task) => {
    return {
        type: Types.VENTILATOR_PATIENT_HISTORY_ADDITIONAL_FEATURES_DATA,
        payload: task,
    }
}

// NX5_PATIENT_HISTORY_TIME_DATA

export const nx5PatientHistoryTimeData = (task) => {

    return {
        type: Types.NX5_PATIENT_HISTORY_TIME_DATA,
        payload: task,
    }
}

export const nx5PatientHistoryGraphApiData = (task) => {
    return {
        type: Types.NX5_PATIENT_HISTORY_GRAPH_API_DATA,
        payload: task,
    }
}

export const nx5PatientHistoryCursorData = (task) => {
    return {
        type: Types.NX5_PATIENT_HISTORY_CURSOR_DATA,
        payload: task,
    }
}

export const nx5PatientHistoryCurrentCursorTime = (task) => {
    return {
        type: Types.NX5_PATIENT_HISTORY_CURRENT_CURSOR_TIME,
        payload: task,
    }
}

export const nx5PatientHistoryLiveAlarmHistoryData = (task) => {
    return {
        type: Types.NX5_PATIENT_HISTORY_LIVE_ALARM_HISTORY_DATA,
        payload: task,
    };
};